'use client';

import React from 'react';
import { RelatedPostsCard } from '@/components/(blog)/post/RelatedPostsCard';
import { ImageNode } from '@/types/global';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';

export interface PostType {
    uri: string;
    title: string;
    databaseId: number;
    featuredImage?: ImageNode;
}

interface PostTemplateProps {
    editorsChoice?: PostType[];
}

export interface EditorsPostProps {
    slug: string;
    title: string;
    featuredImage?: ImageNode;
    databaseId?: number;
    index?: number;
    aside?: boolean;
    date?: string | undefined;
    excerpt?: string | undefined;
    /** Image display width, when the default (sidebar or 360px) does not fit the layout */
    sizes?: string;
    /** Sidebar row from lg up, card below (see RelatedPostsCard) */
    responsiveAside?: boolean;
}

const EditorsChoice: React.FC<PostTemplateProps> = ({ editorsChoice }) => {
    if (!Array.isArray(editorsChoice)) {
        return null;
    }

    return (
        <>
            {editorsChoice.length > 0 && (
                <div className='relative'>
                    <div
                        className={
                            'mb-4 flex w-full xl:text-xl border-b border-black/30 dark:border-white/20'
                        }
                    >
                        <p className={'border-b-2 pb-2 border-progress'}> مقالات منتخب</p>
                    </div>
                    <ScrollArea
                        dir={'rtl'}
                        className='lg:flex lg:flex-col lg:max-h-[500px] gap-2 max-lg:hidden'
                    >
                        {editorsChoice.map((post, index) => (
                            <RelatedPostsCard
                                key={index}
                                slug={post.uri}
                                title={post.title}
                                databaseId={post.databaseId}
                                featuredImage={post.featuredImage}
                                index={index}
                                aside={true}
                            />
                        ))}
                    </ScrollArea>
                    <ScrollArea
                        dir={'rtl'}
                        className='lg:max-h-[300px] whitespace-nowrap container px-0 pb-4 lg:hidden'
                    >
                        <div className='flex w-max xl:w-full gap-4'>
                            {editorsChoice.map((post, index) => (
                                <div
                                    key={index}
                                    className={
                                        'flex flex-col w-64 transition-all rounded-lg overflow-hidden border dark:border-white/30 gap-3 hover:bg-gray-50 dark:hover:bg-white/10'
                                    }
                                >
                                    <RelatedPostsCard
                                        slug={post.uri}
                                        title={post.title}
                                        databaseId={post.databaseId}
                                        featuredImage={post.featuredImage}
                                        index={index}
                                    />
                                </div>
                            ))}
                        </div>
                        <ScrollBar orientation='horizontal' />
                    </ScrollArea>
                </div>
            )}
        </>
    );
};

export default EditorsChoice;
